import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { LucideAngularModule, Instagram, Facebook, Youtube, MessageCircle } from 'lucide-angular';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink, LucideAngularModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  readonly InstagramIcon = Instagram;
  readonly FacebookIcon = Facebook;
  readonly YoutubeIcon = Youtube;
  readonly WhatsAppIcon = MessageCircle;
  readonly currentYear = new Date().getFullYear();

  constructor(private router: Router) {}

  handleLinkClick(targetPath: string): void {
    if (this.router.url === targetPath || this.router.url === `${targetPath}/` || this.router.url === `${targetPath}#`) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
